<template>
    <div>
        <div v-for="(index, i) in getDiagramCount.length" :key="i">
            <apexchart type="line" height="320" :options="chartOptions(i)" :series="getSeries(i)"></apexchart>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import {Money} from './../../../services/Money.js';

export default {
    name: "LineSynchronized",
    components: {
        apexchart: VueApexCharts,
    },
    data: function() {
        return {
            money:new Money(),
            colors:['#008000', '#FF0000', '#0000FF', '#FFFF00', '#800000', '#FF8C00', '#800080', '#FF00FF', '#808080', '#00FFFF', '#00FF00', '#FF1493', '#DEB887', '#FFD700', '#FFC0CB', '#90EE90', '#BC8F8F', '#00BFFF', '#7B68EE', '#4682B4', '#ADFF2F', '#808000', '#008080', '#DCDCDC', '#8B4513', '#2F4F4F', '#B8860B', '#EEE8AA', '#DC143C', '#FA8072']
        }
    },
    props:{
        chartData:{
            type:Object
        } ,
        documents:{
            type:Array
        },
        analyzeType:{
            type:String,
        },
        analyzeLevel: {
            type: Object
        },
        currency:{
            type:String
        },
    },
    computed:{
        series() {
            return this.generateChartData(this.documents, this.chartData.crit_1,this.chartData.crit_2);
        },

        getDiagramCount(){
            let categories = [];
            if(this.chartData.crit_1 != 'date_item_name' || this.chartData.crit_1 == 'date_item_name' && this.analyzeLevel.date_segregation == 'year'){
                categories = [...new Set(this.documents.map((item) => item[this.chartData.crit_1]))];
                categories =  categories.filter(obj => obj !== 'REST');
                categories.sort((a, b) => {
                    const aOrder = this.documents.find(obj => obj[this.chartData.crit_1] === a)[this.chartData.crit_1.replace('_name', '_order')];
                    const bOrder = this.documents.find(obj => obj[this.chartData.crit_1] === b)[this.chartData.crit_1.replace('_name', '_order')];
                    return aOrder - bOrder;
                });
            }
            else{
                const dateValues = this.documents.map(obj => new Date(obj['date_chart']));
                const minDate = new Date(Math.min(...dateValues));
                const maxDate = new Date(Math.max(...dateValues));
                minDate.setDate(1);
                minDate.setHours(0, 0, 0, 0);
                maxDate.setHours(0, 0, 0, 0);
                // Utwórz listę miesięcy między minimalną a maksymalną datą
                const monthsBetween = [];
                let currentDate = minDate;
                while (currentDate <= maxDate) {
                    monthsBetween.push(currentDate.toLocaleString(navigator.language, {
                        year: 'numeric',
                        month: 'long'
                    }));
                    currentDate.setMonth(currentDate.getMonth() + 1);
                    currentDate.setHours(0, 0, 0, 0);
                }
                categories = monthsBetween;
            }
            return categories

        }
    },
    methods: {
        roundToNextTen(value) {
            // Zaokrąglanie w górę do najbliższej potęgi 10
            return Math.ceil(value / 10) * 10;
        },

        formatWithZeros(value) {
            // Formatowanie wartości z zerami
            return value.toFixed(0);
        },

        getMax() {
            let max = Number.NEGATIVE_INFINITY;

            for (const obj of this.series) {
                const maxValueInSeries = Math.max(...obj.data);
                // Zaokrąglenie wartości do najbliżej większej potęgi 10
                const roundedValue = this.roundToNextTen(maxValueInSeries);
                // Formatowanie wartości z zerami
                const formattedValue = parseFloat(this.formatWithZeros(roundedValue));
                if (formattedValue > max) {
                    max = formattedValue;
                }
            }
            return parseFloat(max);
        },
        getTitle(i) {
            return this.getDiagramCount[i];
        },
        getSeries(i){
            let chartData = this.series[i];
            return [chartData]
        },
        chartOptions(i) {
            const objectSumColors = this.generateUniqueColors(this.generateChartData(this.documents, this.chartData.crit_1,this.chartData.crit_2).length);
            const self = this;
            return {
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false
                    },
                    defaultLocale: 'pl',
                    locales: [{
                        name: 'pl',
                        options: {
                            toolbar: {
                                exportToSVG:$.i18n._('chart_export_SVG'),
                                exportToPNG:$.i18n._('chart_export_PNG') ,
                                exportToCSV:$.i18n._('chart_export_CSV'),
                                zoomIn:$.i18n._('chart_zoom_in'),
                                zoomOut:$.i18n._('chart_zoom_out'),
                                pan:$.i18n._('chart_pan'),
                                reset:$.i18n._('chart_reset'),
                            }
                        }
                    }],
                },
                states: {
                    hover: {
                        filter: {
                            type: 'none' // Wyłącza przezroczystość na hover
                        }
                    }
                },
                dataLabels: {
                    enabled: false
                },
                title: {
                    text: self.getTitle(i),
                    align: 'left'
                },
                markers: {
                    size: 0,
                    hover: {
                        sizeOffset: 6
                    }
                },

                xaxis: {
                    categories: this.generateChartData(this.documents, this.chartData.crit_1,this.chartData.crit_2, false)
                },
                yaxis: {
                    title: {
                        text: this.__("net_value_in_base_currency"),
                        style: {
                            fontSize: '9px',
                        }
                    },
                    min: 0, // Minimalna wartość na osi Y
                    max: this.getMax(), // Maksymalna wartość na osi Y
                    labels: {
                        formatter: function (val) {
                            return self.money.localizeWithInt(val);
                        },
                    },
                    forceNiceScale:true,
                },
                colors:this.colors,
                tooltip: {
                    y: {
                        formatter: function (value, { seriesName }) {
                            return self.money.localize(value);
                        },
                        title:{
                            formatter: function (seriesName) {
                                return self.__('net_base_currency_value').replace("base_currency", self.currency)
                            }
                        }
                    },
                    x:{
                        formatter: function (value, series) {
                            return self.generateChartData(self.documents, self.chartData.crit_1,self.chartData.crit_2, false)[value-1];
                        }
                    }
                },
                grid: {
                    borderColor: '#f1f1f1',
                }
            }
        },
        getRandomColor() {
            const letters = '0123456789ABCDEF';
            let color = '#';
            for (let i = 0; i < 6; i++) {
                color += letters[Math.floor(Math.random() * 16)];
            }
            return color;
        },
        generateUniqueColors(count) {
            const uniqueColors = ['#33b2df'];

            while (uniqueColors.length < count) {
                // Wygeneruj nowy kolor i upewnij się, że nie istnieje w tablicy
                const newColor = this.getRandomColor();
                if (!uniqueColors.includes(newColor)) {
                    uniqueColors.push(newColor);
                }
            }

            return uniqueColors;
        },
        generateChartData(data, param2, param3, series = true) {
            let uniqueKeys = [...new Set(data.map((item) => item[param2]))];
            uniqueKeys =  uniqueKeys.filter(obj => obj !== 'REST');
            if(param2 == 'date_item_name' && this.analyzeLevel.date_segregation == 'month'){
                const dateValues = data.map(obj => new Date(obj['date_chart']));
                const minDate = new Date(Math.min(...dateValues));
                const maxDate = new Date(Math.max(...dateValues));
                minDate.setDate(1);
                minDate.setHours(0, 0, 0, 0);
                maxDate.setHours(0, 0, 0, 0);
                // Utwórz listę miesięcy między minimalną a maksymalną datą
                const monthsBetween = [];
                let currentDate = minDate;
                while (currentDate <= maxDate) {
                    monthsBetween.push(currentDate.toLocaleString(navigator.language, {
                        year: 'numeric',
                        month: 'long'
                    }));
                    currentDate.setMonth(currentDate.getMonth() + 1);
                    currentDate.setHours(0, 0, 0, 0);
                }
                uniqueKeys = monthsBetween;
            }
            let categories = [];
            if (param3 != 'date_item_name' || (param3 == 'date_item_name' && this.analyzeLevel.date_segregation == 'year')) {
                categories = [...new Set(data.map((item) => item[param3]))];
                categories =  categories.filter(obj => obj !== 'REST');
                categories.sort((a, b) => {
                    const aOrder = data.find(obj => obj[param3] === a)[param3.replace('_name', '_order')];
                    const bOrder = data.find(obj => obj[param3] === b)[param3.replace('_name', '_order')];
                    return aOrder - bOrder;
                });
            } else {
                const dateValues = data.map(obj => new Date(obj['date_chart']));
                const minDate = new Date(Math.min(...dateValues));
                const maxDate = new Date(Math.max(...dateValues));
                minDate.setDate(1);
                minDate.setHours(0, 0, 0, 0);
                maxDate.setHours(0, 0, 0, 0);
                // Utwórz listę miesięcy między minimalną a maksymalną datą
                const monthsBetween = [];
                let currentDate = minDate;
                while (currentDate <= maxDate) {
                    monthsBetween.push(currentDate.toLocaleString(navigator.language, {
                        year: 'numeric',
                        month: 'long'
                    }));
                    currentDate.setMonth(currentDate.getMonth() + 1);
                    currentDate.setHours(0, 0, 0, 0);
                }
                categories = monthsBetween;
            }

            const seriesData = [];
            let i = 0
            uniqueKeys.sort((a, b) => {

                const aObject = data.find(obj => obj[param2] === a);
                const bObject = data.find(obj => obj[param2] === b);
                if (aObject && bObject) {
                    const aOrder = aObject[param2.replace('_name', '_order')];
                    const bOrder = bObject[param2.replace('_name', '_order')];
                    return aOrder - bOrder;
                } else {
                    return 0; // Lub inna wartość domyślna, zależnie od wymagań
                }
            });
            uniqueKeys.forEach((key) => {
                const dataSeries = categories.map((category) => {
                    const matchingItems = data.filter(
                        (item) => item[param2] === key && item[param3] === category
                    )
                    return matchingItems.reduce((sum, item) => sum + item.net_in_base_currency, 0);
                });

                const series = {
                    name: key,
                    data: dataSeries,
                };
                seriesData.push(series);
            });
            if (series) {
                return seriesData;
            }
            if (!series) {
                if(param3 != 'date_item_name'){
                    categories.sort((a, b) => {
                        const aOrder = data.find(obj => obj[param3] === a)[param3.replace('_name', '_order')];
                        const bOrder = data.find(obj => obj[param3] === b)[param3.replace('_name', '_order')];
                        return aOrder - bOrder;
                    });
                }

                return categories;
            }
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.$forceUpdate();
        });
    }
}
</script>

<style scoped>

</style>
